import React from 'react';

import { Link } from 'react-router-dom';

import { motion } from 'framer-motion';
import { ArrowRight, Shield, Users, Zap } from 'lucide-react';

import ModernButton from './ui/ModernButton';

interface HomeCTAProps {
  className?: string;
}

const HomeCTA: React.FC<HomeCTAProps> = ({ className = '' }) => {
  return (
    <section className={`py-20 my-8 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ type: 'spring', stiffness: 300, damping: 10 }}
          className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl shadow-2xl overflow-hidden border border-blue-400"
        >
          <div className="px-8 py-16 md:p-16 text-center md:text-left md:flex md:items-center md:justify-between relative">
            {/* Elementos decorativos para aspecto premium */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500 opacity-10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-indigo-500 opacity-10 rounded-full -ml-24 -mb-24"></div>

            <div className="relative z-10">
              <div className="mb-4">
                <span className="bg-blue-900 bg-opacity-50 text-blue-200 text-xs font-medium px-4 py-1.5 rounded-full uppercase tracking-wider border border-blue-400">
                  Servicio Exclusivo
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
                Eleve su Empresa al <span className="text-blue-300">Siguiente Nivel</span>
              </h2>
              <p className="text-blue-100 mb-8 md:mb-0 max-w-2xl text-lg">
                Agende una consulta exclusiva con nuestros especialistas y descubra cómo nuestras
                soluciones personalizadas pueden transformar su negocio y maximizar su inversión.
              </p>

              <div className="flex flex-wrap gap-4 mt-6 mb-8 md:mb-0">
                <div className="flex items-center px-3 py-1.5 bg-white bg-opacity-10 backdrop-blur-sm rounded-lg">
                  <Shield className="h-5 w-5 text-blue-300 mr-2" />
                  <span className="text-sm font-medium text-blue-100">
                    Garantía de Satisfacción
                  </span>
                </div>
                <div className="flex items-center px-3 py-1.5 bg-white bg-opacity-10 backdrop-blur-sm rounded-lg">
                  <Users className="h-5 w-5 text-blue-300 mr-2" />
                  <span className="text-sm font-medium text-blue-100">Atención Personalizada</span>
                </div>
                <div className="flex items-center px-3 py-1.5 bg-white bg-opacity-10 backdrop-blur-sm rounded-lg">
                  <Zap className="h-5 w-5 text-blue-300 mr-2" />
                  <span className="text-sm font-medium text-blue-100">Implementación Rápida</span>
                </div>
              </div>
            </div>
            <div className="mt-8 md:mt-0 relative z-10">
              <div className="bg-white bg-opacity-10 p-1 rounded-xl backdrop-blur-sm">
                <div className="text-xs text-blue-200 mb-3 font-medium text-center">
                  <span className="inline-block px-3 py-1 bg-blue-900 bg-opacity-50 rounded-full">
                    Plazas limitadas disponibles
                  </span>
                </div>
                <Link
                  to="/contacto"
                  onClick={() => window.scrollTo(0, 0)}
                  state={{
                    subject: 'Solicitud de Consulta Exclusiva para Transformación Empresarial',
                    message:
                      'Me interesa elevar mi empresa al siguiente nivel con sus soluciones industriales personalizadas. Quisiera agendar una consulta exclusiva con sus especialistas para discutir cómo pueden transformar mi negocio y maximizar mi inversión con implementación rápida y atención personalizada.',
                  }}
                >
                  <ModernButton variant="primary" size="lg" className="min-w-[250px] shadow-lg">
                    Solicitar Consulta Exclusiva
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </ModernButton>
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HomeCTA;
